import type { ComponentProps } from 'react'
import React, { useState } from 'react'
import { isValidCPF, maskCPF } from '../../helpers/utilsValidation'
import { Label } from '~/design-system/primitives'
import { cleanCpf } from '~/helpers/document.helper'
import { cn } from '~/lib/cn'

type CpfNumberInputProps = {
  onCpfChange?: (number: string) => void
} & ComponentProps<'input'>

const CpfNumberInput: React.FC<CpfNumberInputProps> = ({ onCpfChange, ...props }) => {
  const [cpf, setCpf] = useState('')
  const [isValid, setIsValid] = useState(true)

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    let value = event.target.value

    const cleanValue = cleanCpf(value)

    value = maskCPF(cleanValue)
    setCpf(value)

    const isValidCpfLength = cleanValue.length === 11
    const isValidCpf = isValidCpfLength && isValidCPF(cleanValue)
    setIsValid(isValidCpf)

    onCpfChange?.(cleanValue)
  }

  return (
    <>
      <Label className="" htmlFor="cpf">
        CPF *
      </Label>

      <input
        className={cn(
          'w-full px-2 py-1.5  min-w-0 outline bg-white text-sm text-gray-800 disabled:text-primary-black max-h-9  border rounded  border-gray-60  outline-0',
          !isValid && 'border border-red-700',
        )}
        id="cpf"
        maxLength={14}
        name="cpf"
        type="tel"
        value={cpf}
        onChange={handleChange}
        {...props}
      />

      <div>
        {!isValid ? (
          <p className="text-red-700 text-sm">Número de CPF inválido.</p>
        ) : (
          <p className="text-sm text-gray-80">Digite o CPF do titular do cartão</p>
        )}
      </div>
    </>
  )
}

export default CpfNumberInput
